import React from "react";
import { Box, Checkbox, FormControl, FormControlLabel, FormHelperText, Link, Typography, } from "@material-ui/core";
import { Translate as T } from "react-localize-redux";
import { makeStyles } from "@material-ui/core/styles";
import TermsModal from "./components/TermsModal/TermsModal";
import { useCheckoutContext } from "../../../context/useCheckoutContext";
var useStyles = makeStyles(function (theme) { return ({
    check: {
        color: theme.typography.h1.color + " !important",
    },
    label: {
        color: "#293036",
        fontSize: "14px",
        fontWeight: "bold",
    },
    link: {
        color: theme.typography.h1.color + " !important",
    },
}); });
export var TermsConditions = function (_a) {
    var setOpenTerms = _a.setOpenTerms, open = _a.open, form = _a.form;
    var _b, _c, _d;
    var classes = useStyles();
    var termsText = useCheckoutContext().termsAndConditions;
    return (React.createElement(React.Fragment, null, !!termsText ? (React.createElement(Box, null,
        React.createElement(Box, null,
            React.createElement(FormControl, null,
                React.createElement(FormControlLabel, { labelPlacement: "end", label: React.createElement(Typography, { className: classes.label },
                        React.createElement(T, { id: "agree" }),
                        React.createElement(Link, { onClick: function () { return setOpenTerms(true); }, className: classes.link },
                            React.createElement(T, { id: "terms" }))), control: React.createElement(Checkbox, { className: classes.check }), inputRef: form &&
                        // @ts-ignore
                        form.register({
                            required: React.createElement(T, { id: "form.fieldRequired" }),
                        }), name: "terms" }),
                React.createElement(FormHelperText, { margin: "dense", required: true, style: { color: "rgba(226,71,99,1)" } }, 
                //@ts-ignore
                !!((_b = form === null || form === void 0 ? void 0 : form.errors) === null || _b === void 0 ? void 0 : _b.terms) && ((_d = (_c = form === null || form === void 0 ? void 0 : form.errors) === null || _c === void 0 ? void 0 : _c.terms) === null || _d === void 0 ? void 0 : _d.message)))),
        open && React.createElement(TermsModal, { setOpenTerms: setOpenTerms }))) : (React.createElement(Box, { mt: 2 }))));
};
export default TermsConditions;
